// matches CHART_INK.grid from shared/config/colors.jsx
$separator-color: rgba(137, 135, 129, 0.2);

//
//

.list {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  margin: 1rem 0;
  padding: 1rem;
  border-radius: 1rem;
  background-color: var(--tg-theme-secondary-bg-color);

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;

    h2 {
      margin: 0;
      font-size: 1.1rem;
      font-weight: 600;
    }
  }

  &__error {
    margin: 0;
    padding: 1rem 0;
    text-align: center;
    color: var(--tg-theme-subtitle-text-color);
  }

  &__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    margin: 0;
    padding: 1.5rem 0;
    text-align: center;
    color: var(--tg-theme-subtitle-text-color);

    i {
      font-size: 1.5rem;
      opacity: 0.6;
    }
  }
}

//
//

.picker {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.75rem;
  border: 1px solid var(--tg-theme-subtitle-text-color);
  border-radius: 1rem;
  font-size: 0.85rem;
  white-space: nowrap;
  color: var(--tg-theme-subtitle-text-color);

  i {
    font-size: 0.8rem;
  }

  // invisible native input stretched over the pill - a tap opens the system date picker
  input {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    border: 0;
    opacity: 0;
    cursor: pointer;
  }
}

//
//

.days {
  display: flex;
  align-items: stretch;
  gap: 0.3rem;

  // nested for specificity over the Btn wrapper design resets
  .days__arrow {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    width: 1.9rem;
    border-radius: 0.65rem;
    font-size: 0.8rem;
    color: var(--tg-theme-subtitle-text-color);
    background-color: var(--tg-theme-bg-color);
  }

  // nested for specificity over the Btn wrapper design resets
  .day {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.15rem;
    flex: 1 1 0;
    min-width: 0;
    padding: 0.4rem 0.25rem;
    border-radius: 0.65rem;
    color: var(--tg-theme-text-color);
    background-color: var(--tg-theme-bg-color);

    &__weekday {
      font-size: 0.7rem;
      text-transform: uppercase;
      color: var(--tg-theme-subtitle-text-color);
    }

    &__number {
      font-size: 1rem;
      font-weight: 600;
      line-height: 1;
    }

    &_active {
      background-color: var(--tg-theme-button-color);

      &:hover {
        opacity: 1;
      }

      // !important + higher specificity to beat the .btn_wrapper:active resets
      &:active {
        background-color: var(--tg-theme-button-color) !important;
      }

      .day__weekday {
        color: var(--tg-theme-button-text-color);
        opacity: 0.8;
      }

      .day__number {
        color: var(--tg-theme-button-text-color);
      }
    }
  }
}

//
//

.rows {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;

  li:not(:first-child) {
    border-top: 1px solid $separator-color;
  }

  // nested for specificity over the Btn wrapper design resets
  .row {
    display: flex;
    align-items: center;
    gap: 0.65rem;
    width: 100%;
    padding: 0.65rem 0;
    text-align: left;

    &__icon {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      width: 2.35rem;
      height: 2.35rem;
      border-radius: 0.75rem;
      font-size: 0.95rem;
      color: var(--tg-theme-subtitle-text-color);
      background-color: var(--tg-theme-bg-color);
    }

    &__main {
      display: flex;
      flex-direction: column;
      gap: 0.2rem;
      flex: 1;
      min-width: 0;
    }

    &__title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 0.95rem;
      font-weight: 500;
      color: var(--tg-theme-text-color);
    }

    &__sub {
      display: flex;
      flex-wrap: wrap;
      gap: 0.2rem 0.6rem;
      font-size: 0.8rem;
      color: var(--tg-theme-subtitle-text-color);

      span {
        display: inline-flex;
        align-items: center;
        gap: 0.25rem;
      }

      i {
        // ENABLE IF USE DOTS INSTEAD OF EMOJIS
        // width: 0.4rem;
        // height: 0.4rem;
        // border-radius: 50%;
      }
    }

    &__kcal {
      flex-shrink: 0;
      font-size: 0.95rem;
      font-weight: 600;
      white-space: nowrap;
      color: var(--tg-theme-text-color);

      small {
        margin-left: 0.2rem;
        font-size: 0.75rem;
        font-weight: 400;
        color: var(--tg-theme-subtitle-text-color);
      }
    }

    &__chevron {
      flex-shrink: 0;
      font-size: 0.8rem;
      color: var(--tg-theme-subtitle-text-color);
    }
  }
}

//
//

.total {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.35rem 0.75rem;
  padding-top: 0.65rem;
  border-top: 1px solid $separator-color;
  font-size: 0.875rem;

  &__label {
    font-weight: 600;
  }

  &__values {
    display: flex;
    flex: 1;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.25rem 0.75rem;
    color: var(--tg-theme-subtitle-text-color);

    &-macros {
      display: flex;
      flex: 1;
      justify-content: space-around;
    }

    b {
      margin-left: 0.2rem;
      font-weight: 600;
      color: var(--tg-theme-text-color);
    }
  }
}
